import { getSaleOrderByDealId } from 'features/salesOrder/services';
import { ISaleOrderListItem } from 'features/salesOrder/types';

export type DealSaleOrderConflict = {
	crmTicket: number;
	quotationId: number;
	saleOrder: ISaleOrderListItem;
};

export const findSaleOrderConflictForDeal = async (
	crmTicket: number,
	quotationId: number,
): Promise<DealSaleOrderConflict | null> => {
	if (!crmTicket || crmTicket < 1) {
		return null;
	}

	try {
		const response = await getSaleOrderByDealId(crmTicket);
		const existing = response.data?.elements?.[0];
		if (!existing?.id) {
			return null;
		}
		return {
			crmTicket,
			quotationId,
			saleOrder: existing,
		};
	} catch {
		return null;
	}
};
